import { useState, useCallback } from 'react';
import { useApi } from './useApi';

export const useOrders = () => {
  const [orders, setOrders] = useState([]);
  const [currentOrder, setCurrentOrder] = useState(null);
  const { loading, error, get, post } = useApi();

  const fetchOrders = useCallback(async () => {
    const result = await get('/customer/orders');
    
    if (result.success) {
      // El backend retorna paginación: { data: [...], meta: {...} }
      const ordersData = result.data?.data || result.data || [];
      setOrders(ordersData);
    }
    
    return result;
  }, [get]);

  const fetchOrderByCode = useCallback(async (code) => {
    const result = await get(`/customer/orders/${code}`);
    
    if (result.success) {
      setCurrentOrder(result.data.order || result.data);
    }
    
    return result;
  }, [get]);

  const createOrder = useCallback(async (orderData) => {
    const result = await post('/customer/orders', orderData);
    
    if (result.success) {
      setCurrentOrder(result.data.order || result.data);
    }
    
    return result;
  }, [post]);

  return {
    orders,
    currentOrder,
    loading,
    error,
    fetchOrders,
    fetchOrderByCode,
    createOrder,
    setCurrentOrder,
  };
};

export default useOrders;
